import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=5f64fe96&scoped=true&"
import script from "./global-search.vue?vue&type=script&lang=js&"
export * from "./global-search.vue?vue&type=script&lang=js&"
import style0 from "./global-search.vue?vue&type=style&index=0&id=5f64fe96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64fe96",
  null
  
)

export default component.exports